export default __webpack_public_path__ + "static/Cart-Mobile-489c45a77953277a3e939854378275c1.webp";